// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__yEgVW","modalBackground":"Modal_modalBackground__X+1v0","modalContent":"Modal_modalContent__JODE3","close":"Modal_close__nnot4"};